/* eslint-disable jsx-a11y/no-static-element-interactions */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';

import { Badge } from '../../Global/Icons';
import { setActiveGoodyAsync } from '../../../actions/activeGoodies';

function GoodyItem({ type, name, id, isActive, isNew, setActiveGoody }) {
  const classes = classnames('goodies__list__goody', {
    'goodies__list__goody--is-active': isActive,
    'goodies__list__goody--is-new': isNew,
  });

  // If this goody is active, remove it on click.
  const nextActiveGoodyId = isActive
    ? undefined
    : id;

  return (
    <div className={classes} onClick={() => setActiveGoody(type, nextActiveGoodyId)}>
      <img
        alt={`${type} goody`}
        src={`extension-assets/${type}/${name}.svg`}
      />
      <Badge classes="badge" />
    </div>
  );
}

GoodyItem.propTypes = {
  type: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
  isNew: PropTypes.bool.isRequired,
};

const mapDispatchToProps = dispatch => ({
  setActiveGoody: (goodyType, goodyId) => {
    dispatch(setActiveGoodyAsync(goodyType, goodyId));
  },
});

export default connect(null, mapDispatchToProps)(GoodyItem);



// WEBPACK FOOTER //
// ./src/components/Extension/GoodyBag/GoodyItem.js